module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0175.jpg?v=6370bee9";